/**
 * 下载页面
 * Created by Yata on 2017/9/21 0001.
 */

export default [{
    path: '/download',
    name: 'download',
    component: () => import('../components/download/download.vue'),
    meta: {
        title: "停车帮助"
    }
}]
